import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import {
    Tabs,
    Tab,
    Box,
    Typography,
    Fade,
    Button,
    Paper,
    Grid,
    IconButton,
    Chip,
    Alert,
    CircularProgress,
    Avatar,
    Slide,
    Tooltip as MuiTooltip,
} from "@mui/material";
import { useDropzone } from "react-dropzone";
import UseToast from "../../UseToast";


export const MainNavigationTab = () => {
    const [buttonColor, setButtonColor] = useState("#000000");
    const [value, setValue] = useState(2);
    const [subValue, setSubValue] = useState(0); // For sub-tabs under Category Manager
    const { showMsgSuccessToast, showErrorToast } = UseToast();
    const { id, userId } = useParams();
    const navigate = useNavigate();
    const isEffectRan = useRef(false);
    const [isLoading, setIsLoading] = useState(false);


    const [categories, setCategories] = useState([]);
    const [frontendCategories, setFrontendCategories] = useState([]);


    const [frontendSubCategories, setFrontendSubCategories] = useState([]);



    const [allSubCategories, setAllCategories] = useState([]);
    const [isPrimary, setIsPrimary] = useState(false);
    const [parentMenuName, setParentMenuName] = useState('');
    const [chilmenuName, setChildMenuName] = useState('');
    const [parentMenuID, SetParentMenuID] = useState(null);
    const [linkbtnId, setLinkedBtnId] = useState(null);
    const [menuLevel, setMenuLevel] = useState('');
    const [mainMeuLinked, setMainMeuLinked] = useState(false);
    const [menuUrl, setMenuUrl] = useState('');

    const [settings, setSettings] = useState({
        btnId: id,
        userId: null,
        buttonText: '',

        globalSettings: {
            cornerRadius: 0,
            height: 50,
            width: 150,
            outlineColor: '#000000',
            outlineThickness: 1,
            fillColor: '#fff',
            font: 'Arial',
            fontColor: '#127E10',
            fontSize: 16,
            shadow: {
                angle: 5,
                size: 10,
                distance: 5,
                alpha: 0.5,
                color: '#FF5733', // Bright orange
            },
            highlight: {
                borderColor: '#000000',
                fillColor: '#fff',
                fontColor: '#000000',
            },
            clickSound: '',
            clickSoundFilename: null,
            clickSoundVolume: 1,
            textAlign: 'center',
            marginBottom: 2,
            lineHeight: 1,
            padding: 10,
        },
        customSettings: {
            cornerRadius: 0,
            height: 50,
            width: 150,
            outlineColor: '#000000',
            outlineThickness: 1,
            fillColor: '#fff',
            font: 'Arial',
            fontColor: '#127E10',
            fontSize: 16,
            shadow: {
                angle: 5,
                size: 10,
                distance: 5,
                alpha: 0.5,
                color: '#FF5733', // Bright orange
            },
            highlight: {
                borderColor: '#000000',
                fillColor: '#fff',
                fontColor: '#000000',
            },
            clickSound: '',
            clickSoundFilename: null,
            clickSoundVolume: 1,
            textAlign: 'center',
            marginBottom: 2,
            pngBtnenabled: false,
            hideBtnText: false,
            btnPng: null,
            btnPngFileName: null,
            lineHeight: 1,
            padding: 10,
        }, // Custom overrides
        enabled: false,
    });



    const fetchBrandColor = async () => {
        try {
            if (userId) {
                const res = await axios.get(`/auth/aiform/all/${userId}`);

                const data = res.data?.UserData?.brandColor;
                setButtonColor(data);
            }

        } catch (error) {
            console.log(error)
        }
    }

    const fetchWayfinderData = async () => {
        setIsLoading(true);
        try {
            const categoriesResponse = await axios.get(
                `/api/wayfinder/get-categories/${userId}`
            );
            console.log("cat resp", categoriesResponse);
            if (!categoriesResponse.data.error) {
                const frontendCatNames = (categoriesResponse.data?.data || []).map(
                    (fc) => ({
                        ...fc,
                        matchedCategoryName: fc?.linkedLocation
                            ? `(${fc?.linkedLocation})`
                            : "",
                    })
                );
                setFrontendCategories(frontendCatNames);

                setFrontendSubCategories(categoriesResponse.data?.data || []);
                setCategories(categoriesResponse.data?.data.categories || []);
                setButtonColor(categoriesResponse.data?.site_brand_color || "#000000");
            }

            // Fetch subcategories
            const subcategoriesResponse = await axios.get(
                `/api/wayfinder/subcategory/${userId}`
            );
            if (!subcategoriesResponse.data.error) {
                setAllCategories(subcategoriesResponse.data?.data || []);
            }
        } catch (error) {
            console.error("Error fetching wayfinder data:", error);
            showErrorToast("Failed to load wayfinder data");
        } finally {
            setIsLoading(false);
        }
    };

    const handleTabChange = (event, newValue) => {
        setValue(newValue);
        setSubValue(0); // Reset sub-tab when switching main tabs
    };


    const goBack = () => {
        navigate(-1);
    };

    const [locations, setLocations] = useState([]);






    // Update useEffect to fetch locations
    useEffect(() => {
        if (userId && !isEffectRan.current) {
            isEffectRan.current = true;
            fetchWayfinderData();
            fetchBrandColor();

        }
    }, [userId]);



    useEffect(() => {
        fetch(`/api/button-settings/${id}/${userId}`)
            .then(res => res.json())
            .then(data => {
                if (!data.error) {
                    const result = data?.data;
                    setSettings(prevSettings => ({
                        ...prevSettings,
                        globalSettings: {
                            ...prevSettings?.globalSettings,
                            ...result?.globalSettings,
                        },
                        customSettings: {
                            ...prevSettings?.customSettings,
                            ...result?.customSettings,
                        },
                        enabled: result?.enabled,
                        btnId: id,
                        buttonText: result?.buttonText,
                    }));

                    setButtonColor(data?.site_brand_color);
                    setMenuUrl(data?.menu_client_url);

                    if (result?.menuLevel === 'primary' || result?.menuLevel === 'frontend') {
                        setIsPrimary(true);
                    }

                    setMenuLevel(result?.menuLevel);
                    setParentMenuName(result?.parentMenuName);
                    setChildMenuName(result?.chilmenuName);
                    SetParentMenuID(result?.parentMenuID);
                    setLinkedBtnId(result?.linkbtnId);
                    setMainMeuLinked(result?.mainMeuLinked);
                }
            })
            .catch(() => console.log('Button not found, creating new settings.'));
    }, [id]);



    return (
        < >
            <div>
                Navigation Settings
            </div>
        </ >
    );
};